<template>
    <c-app-recent
        icon      = "mdi-history"
        :tooltip  = "$t('navtop.recent.incident')"
        :loader   = "load"
        @selected = "onSelected"
    >
        <template v-slot:title="{ item }">
            <div>
                {{ item.recent.incident.id }} - {{ item.recent.incident.typeName }}
            </div>

            <v-spacer />
            <div class="primary--text">
                {{  item.recent.incident.sites[0].customer.name }}
            </div>
            <c-clipboard-chip
                v-if = "item.recent.hasClipboardEntries"
                size = "xsmall"
            />
        </template>

        <template v-slot:subtitle="{ item }" >
            <div class="recent-subtitle">
                {{ item.incident.sites[0].street }}
            </div>
            <div class="recent-subtitle v-flex">
                <div>
                    {{ item.incident.sites[0].zip }} {{ item.incident.sites[0].city }}
                </div>
                <v-spacer />
                <div style="float: right; font-size: 8pt; padding-top: 1px">
                    {{ format(item.accesstime) }}
                </div>
            </div>
        </template>
    </c-app-recent>
</template>

<script>

import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc.js";
import CAppRecent from "@/modules/core/components/app/CAppRecent";
import CClipboardChip from "@/modules/inc/steps/components/common/clipboard/CClipboardChip.vue";

export default {
    name: "CAppRecentIncident",
    components: {
        CClipboardChip,
        CAppRecent
    },

    data: () => ({
    }),

    methods: {
        load () {
            return Inc.recents();
        },

        format (value) {
            return Core.format.datetime.display(value);
        },

        onSelected (item) {
            Inc.goto(this, item.incident.id);
            this.menuOpen = false;
        },
    }
}
</script>

<style scoped>

.recent-subtitle {
    font-size: 9pt;
    padding-top: 2px;
}

</style>